// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__qB2MX","iconColor":"Navbar_iconColor__Krkud","search":"Navbar_search__ktnsM","icon":"Navbar_icon__l5qJX"};